import { Form } from 'antd';
import { useField } from 'formik';
import { isEqual } from 'lodash/fp';
import { type InputFieldProps } from '../../../components/fields/InputField';
import { StyledTextFieldWrapper } from './shared';
import useRenderTooltip from './useRenderTooltip';
import { getTextFieldState } from './utils';

const PasswordField = ({ placeholder, status, label, required = false, name, itemProps, tooltip }: InputFieldProps) => {
    const [field, meta] = useField({ name });

    const renderTooltip = useRenderTooltip(tooltip);

    const hasError = !!meta?.error && (meta?.touched || !isEqual(meta?.initialValue, meta?.value));
    const errorMessage = Array.isArray(meta?.error) ? '' : meta?.error;

    return (
        <Form.Item {...itemProps} required={required}>
            <StyledTextFieldWrapper state={hasError ? 'error' : getTextFieldState(status)}>
                {label && (
                    <span slot="label">
                        {label}
                        {renderTooltip()}
                    </span>
                )}
                {itemProps?.help && <span slot="description">{itemProps?.help}</span>}
                <input {...field} placeholder={placeholder} required={required} type="password" />
                {hasError && <span slot="message">{errorMessage}</span>}
            </StyledTextFieldWrapper>
        </Form.Item>
    );
};

export default PasswordField;
